import React from 'react';
import { motion } from 'framer-motion';
import { Map, ArrowRight } from 'lucide-react';
import { RADIUS } from '../../../config/designTokens';
interface JourneyEmptyStateProps {
  onNavigate: (view: string) => void;
}
export function JourneyEmptyState({
  onNavigate
}: JourneyEmptyStateProps) {
  return <div className="flex flex-col items-center text-center pt-12 pb-24 px-4 relative z-10" data-id="element-1914">
      <motion.div initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} className="max-w-sm w-full" data-id="element-1915">
        <div className="relative w-32 h-32 mx-auto mb-6" data-id="element-1916">
          <div className="absolute inset-0 bg-blue-100 rounded-full animate-pulse" data-id="element-1917" />
          <div className="absolute inset-2 bg-blue-50 rounded-full flex items-center justify-center border-4 border-white shadow-sm" data-id="element-1918">
            <Map className="w-12 h-12 text-blue-400" data-id="element-1919" />
          </div>
        </div>

        <h2 className="text-2xl font-black text-slate-800 mb-3" data-id="element-1920">
          Jouw reis begint hier!
        </h2>
        <p className="text-slate-600 font-medium mb-8 leading-relaxed" data-id="element-1921">
          Je hebt nog geen vaardigheden geoefend. Zodra je begint, verschijnt
          hier jouw persoonlijke avonturenpad.
        </p>

        <button onClick={() => onNavigate('modules')} className={`w-full py-4 bg-blue-500 text-white font-black text-lg ${RADIUS.button} shadow-md hover:bg-blue-600 active:scale-95 transition-all flex items-center justify-center gap-2`} data-id="element-1922">
          Start je reis
          <ArrowRight className="w-5 h-5" data-id="element-1923" />
        </button>
      </motion.div>
    </div>;
}